/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SentryErrorTestRouteImport } from './routes/sentry-error-test'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HelpGuidesRouteImport } from './routes/help-guides'
import { Route as HelpCenter2RouteImport } from './routes/help-center2'
import { Route as HelpCenterRouteImport } from './routes/help-center'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CaseFilingRouteImport } from './routes/case-filing'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as BackofficeRouteImport } from './routes/_backoffice'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard.index'
import { Route as SettingsCaseActivitySettingsRouteImport } from './routes/settings.case-activity-settings'
import { Route as SettingsActiveUserSessionsRouteImport } from './routes/settings.active-user-sessions'
import { Route as EmailVerifyRouteImport } from './routes/email.verify'
import { Route as DashboardUsersRouteImport } from './routes/_dashboard.users'
import { Route as DashboardTibolRouteImport } from './routes/_dashboard.tibol'
import { Route as DashboardTextEditorRouteImport } from './routes/_dashboard.text-editor'
import { Route as DashboardSettingsRouteImport } from './routes/_dashboard.settings'
import { Route as DashboardProfileRouteImport } from './routes/_dashboard.profile'
import { Route as DashboardOccDashboardRouteImport } from './routes/_dashboard.occ-dashboard'
import { Route as DashboardNotificationsRouteImport } from './routes/_dashboard.notifications'
import { Route as DashboardJudgeDashboardRouteImport } from './routes/_dashboard.judge-dashboard'
import { Route as DashboardHelpTopicsRouteImport } from './routes/_dashboard.help-topics'
import { Route as DashboardHelpRouteImport } from './routes/_dashboard.help'
import { Route as DashboardFormTemplatesRouteImport } from './routes/_dashboard.form-templates'
import { Route as DashboardChangelogsRouteImport } from './routes/_dashboard.changelogs'
import { Route as DashboardCasesRouteImport } from './routes/_dashboard.cases'
import { Route as DashboardCaseProcessingRouteImport } from './routes/_dashboard.case-processing'
import { Route as DashboardCalendarOfEventsRouteImport } from './routes/_dashboard.calendar-of-events'
import { Route as DashboardCalendarRouteImport } from './routes/_dashboard.calendar'
import { Route as DashboardBccDashboardRouteImport } from './routes/_dashboard.bcc-dashboard'
import { Route as DashboardArticlesRouteImport } from './routes/_dashboard.articles'
import { Route as BackofficeStenographicNotesRouteImport } from './routes/_backoffice.stenographic-notes'
import { Route as BackofficeStatisticsRouteImport } from './routes/_backoffice.statistics'
import { Route as BackofficeSheriffReportsRouteImport } from './routes/_backoffice.sheriff-reports'
import { Route as BackofficeServingRouteImport } from './routes/_backoffice.serving'
import { Route as BackofficeReportStatisticRouteImport } from './routes/_backoffice.report-statistic'
import { Route as BackofficeRaffleRouteImport } from './routes/_backoffice.raffle'
import { Route as BackofficePublicProfileRouteImport } from './routes/_backoffice.public-profile'
import { Route as BackofficeNewCasesRouteImport } from './routes/_backoffice.new-cases'
import { Route as BackofficeCaseEvaluationRouteImport } from './routes/_backoffice.case-evaluation'
import { Route as BackofficeCaseClassificationRouteImport } from './routes/_backoffice.case-classification'
import { Route as BackofficeBranchStatisticsRouteImport } from './routes/_backoffice.branch-statistics'
import { Route as BackofficeCaseFilingsIndexRouteImport } from './routes/_backoffice.case-filings_.index'
import { Route as DashboardUsersUserIdRouteImport } from './routes/_dashboard.users_.$userId'
import { Route as DashboardUserCreateRouteImport } from './routes/_dashboard.user.create'
import { Route as DashboardSettingsUserAuditLogsRouteImport } from './routes/_dashboard.settings_.user-audit-logs'
import { Route as DashboardSettingsRolesRouteImport } from './routes/_dashboard.settings_.roles'
import { Route as DashboardSettingsRegionRouteImport } from './routes/_dashboard.settings_.region'
import { Route as DashboardSettingsProvinceRouteImport } from './routes/_dashboard.settings_.province'
import { Route as DashboardSettingsKeywordsRouteImport } from './routes/_dashboard.settings_.keywords'
import { Route as DashboardSettingsHelpCategoriesRouteImport } from './routes/_dashboard.settings_.help-categories'
import { Route as DashboardSettingsFormTemplatesRouteImport } from './routes/_dashboard.settings_.form-templates'
import { Route as DashboardSettingsCourtTypeStationRouteImport } from './routes/_dashboard.settings_.court-type-station'
import { Route as DashboardSettingsCourtTypeRouteImport } from './routes/_dashboard.settings_.court-type'
import { Route as DashboardSettingsCourtLevelRouteImport } from './routes/_dashboard.settings_.court-level'
import { Route as DashboardSettingsCaseTypeRouteImport } from './routes/_dashboard.settings_.case-type'
import { Route as DashboardSettingsCaseStagesRouteImport } from './routes/_dashboard.settings_.case-stages'
import { Route as DashboardSettingsCaseCategoryRouteImport } from './routes/_dashboard.settings_.case-category'
import { Route as DashboardSettingsBranchRouteImport } from './routes/_dashboard.settings_.branch'
import { Route as DashboardSettingsArticleCategoriesRouteImport } from './routes/_dashboard.settings_.article-categories'
import { Route as DashboardServingServingIdRouteImport } from './routes/_dashboard.serving_.$servingId'
import { Route as DashboardProfileProfileIdRouteImport } from './routes/_dashboard.profile_.$profileId'
import { Route as DashboardHelpTopicsCreateRouteImport } from './routes/_dashboard.help-topics_.create'
import { Route as DashboardHelpTopicsTopicIdRouteImport } from './routes/_dashboard.help-topics_.$topicId'
import { Route as DashboardFormTemplatesFormIdRouteImport } from './routes/_dashboard.form-templates_.$formId'
import { Route as DashboardCasesCaseIdRouteImport } from './routes/_dashboard.cases_.$caseId'
import { Route as DashboardCaseProcessingCaseIdRouteImport } from './routes/_dashboard.case-processing_.$caseId'
import { Route as DashboardCalendarSelectedDateRouteImport } from './routes/_dashboard.calendar_.selectedDate'
import { Route as DashboardBranchBranchIdRouteImport } from './routes/_dashboard.branch_.$branchId'
import { Route as DashboardArticlesCreateRouteImport } from './routes/_dashboard.articles_.create'
import { Route as DashboardArticlesArticleIdRouteImport } from './routes/_dashboard.articles_.$articleId'
import { Route as BackofficeCasePaymentsCaseIdRouteImport } from './routes/_backoffice.case-payments_.$caseId'
import { Route as BackofficeCaseFilingsCreateRouteImport } from './routes/_backoffice.case-filings_.create'
import { Route as BackofficeCaseFilingsCaseIdRouteImport } from './routes/_backoffice.case-filings_.$caseId'
import { Route as BackofficeCaseEvaluationCreateRouteImport } from './routes/_backoffice.case-evaluation_.create'
import { Route as BackofficeCaseEvaluationCaseEvaluationIdRouteImport } from './routes/_backoffice.case-evaluation_.$caseEvaluationId'
import { Route as BackofficeCaseClassificationCreateRouteImport } from './routes/_backoffice.case-classification_.create'
import { Route as BackofficeCaseClassificationCaseClassificationIdRouteImport } from './routes/_backoffice.case-classification_.$caseClassificationId'
import { Route as DashboardUserUserIdEditRouteImport } from './routes/_dashboard.user_.$userId.edit'
import { Route as DashboardSettingsFormTemplatesCreateRouteImport } from './routes/_dashboard.settings_.form-templates_.create'
import { Route as BackofficeRaffleCreateCaseIdRouteImport } from './routes/_backoffice.raffle_.create_.$caseId'

const SentryErrorTestRoute = SentryErrorTestRouteImport.update({
  id: '/sentry-error-test',
  path: '/sentry-error-test',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpGuidesRoute = HelpGuidesRouteImport.update({
  id: '/help-guides',
  path: '/help-guides',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpCenter2Route = HelpCenter2RouteImport.update({
  id: '/help-center2',
  path: '/help-center2',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpCenterRoute = HelpCenterRouteImport.update({
  id: '/help-center',
  path: '/help-center',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CaseFilingRoute = CaseFilingRouteImport.update({
  id: '/case-filing',
  path: '/case-filing',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const BackofficeRoute = BackofficeRouteImport.update({
  id: '/_backoffice',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const SettingsCaseActivitySettingsRoute =
  SettingsCaseActivitySettingsRouteImport.update({
    id: '/settings/case-activity-settings',
    path: '/settings/case-activity-settings',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsActiveUserSessionsRoute =
  SettingsActiveUserSessionsRouteImport.update({
    id: '/settings/active-user-sessions',
    path: '/settings/active-user-sessions',
    getParentRoute: () => rootRouteImport,
  } as any)
const EmailVerifyRoute = EmailVerifyRouteImport.update({
  id: '/email/verify',
  path: '/email/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardUsersRoute = DashboardUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTibolRoute = DashboardTibolRouteImport.update({
  id: '/tibol',
  path: '/tibol',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTextEditorRoute = DashboardTextEditorRouteImport.update({
  id: '/text-editor',
  path: '/text-editor',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProfileRoute = DashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardOccDashboardRoute = DashboardOccDashboardRouteImport.update({
  id: '/occ-dashboard',
  path: '/occ-dashboard',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardNotificationsRoute = DashboardNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardJudgeDashboardRoute = DashboardJudgeDashboardRouteImport.update({
  id: '/judge-dashboard',
  path: '/judge-dashboard',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardHelpTopicsRoute = DashboardHelpTopicsRouteImport.update({
  id: '/help-topics',
  path: '/help-topics',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardHelpRoute = DashboardHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardFormTemplatesRoute = DashboardFormTemplatesRouteImport.update({
  id: '/form-templates',
  path: '/form-templates',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardChangelogsRoute = DashboardChangelogsRouteImport.update({
  id: '/changelogs',
  path: '/changelogs',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCasesRoute = DashboardCasesRouteImport.update({
  id: '/cases',
  path: '/cases',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCaseProcessingRoute = DashboardCaseProcessingRouteImport.update({
  id: '/case-processing',
  path: '/case-processing',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCalendarOfEventsRoute =
  DashboardCalendarOfEventsRouteImport.update({
    id: '/calendar-of-events',
    path: '/calendar-of-events',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCalendarRoute = DashboardCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBccDashboardRoute = DashboardBccDashboardRouteImport.update({
  id: '/bcc-dashboard',
  path: '/bcc-dashboard',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardArticlesRoute = DashboardArticlesRouteImport.update({
  id: '/articles',
  path: '/articles',
  getParentRoute: () => DashboardRoute,
} as any)
const BackofficeStenographicNotesRoute =
  BackofficeStenographicNotesRouteImport.update({
    id: '/stenographic-notes',
    path: '/stenographic-notes',
    getParentRoute: () => BackofficeRoute,
  } as any)
const BackofficeStatisticsRoute = BackofficeStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => BackofficeRoute,
} as any)
const BackofficeSheriffReportsRoute =
  BackofficeSheriffReportsRouteImport.update({
    id: '/sheriff-reports',
    path: '/sheriff-reports',
    getParentRoute: () => BackofficeRoute,
  } as any)
const BackofficeServingRoute = BackofficeServingRouteImport.update({
  id: '/serving',
  path: '/serving',
  getParentRoute: () => BackofficeRoute,
} as any)
const BackofficeReportStatisticRoute =
  BackofficeReportStatisticRouteImport.update({
    id: '/report-statistic',
    path: '/report-statistic',
    getParentRoute: () => BackofficeRoute,
  } as any)
const BackofficeRaffleRoute = BackofficeRaffleRouteImport.update({
  id: '/raffle',
  path: '/raffle',
  getParentRoute: () => BackofficeRoute,
} as any)
const BackofficePublicProfileRoute = BackofficePublicProfileRouteImport.update({
  id: '/public-profile',
  path: '/public-profile',
  getParentRoute: () => BackofficeRoute,
} as any)
const BackofficeNewCasesRoute = BackofficeNewCasesRouteImport.update({
  id: '/new-cases',
  path: '/new-cases',
  getParentRoute: () => BackofficeRoute,
} as any)
const BackofficeCaseEvaluationRoute =
  BackofficeCaseEvaluationRouteImport.update({
    id: '/case-evaluation',
    path: '/case-evaluation',
    getParentRoute: () => BackofficeRoute,
  } as any)
const BackofficeCaseClassificationRoute =
  BackofficeCaseClassificationRouteImport.update({
    id: '/case-classification',
    path: '/case-classification',
    getParentRoute: () => BackofficeRoute,
  } as any)
const BackofficeBranchStatisticsRoute =
  BackofficeBranchStatisticsRouteImport.update({
    id: '/branch-statistics',
    path: '/branch-statistics',
    getParentRoute: () => BackofficeRoute,
  } as any)
const BackofficeCaseFilingsIndexRoute =
  BackofficeCaseFilingsIndexRouteImport.update({
    id: '/case-filings_/',
    path: '/case-filings/',
    getParentRoute: () => BackofficeRoute,
  } as any)
const DashboardUsersUserIdRoute = DashboardUsersUserIdRouteImport.update({
  id: '/users_/$userId',
  path: '/users/$userId',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardUserCreateRoute = DashboardUserCreateRouteImport.update({
  id: '/user/create',
  path: '/user/create',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsUserAuditLogsRoute =
  DashboardSettingsUserAuditLogsRouteImport.update({
    id: '/settings_/user-audit-logs',
    path: '/settings/user-audit-logs',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsRolesRoute = DashboardSettingsRolesRouteImport.update({
  id: '/settings_/roles',
  path: '/settings/roles',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsRegionRoute = DashboardSettingsRegionRouteImport.update({
  id: '/settings_/region',
  path: '/settings/region',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsProvinceRoute =
  DashboardSettingsProvinceRouteImport.update({
    id: '/settings_/province',
    path: '/settings/province',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsKeywordsRoute =
  DashboardSettingsKeywordsRouteImport.update({
    id: '/settings_/keywords',
    path: '/settings/keywords',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsHelpCategoriesRoute =
  DashboardSettingsHelpCategoriesRouteImport.update({
    id: '/settings_/help-categories',
    path: '/settings/help-categories',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsFormTemplatesRoute =
  DashboardSettingsFormTemplatesRouteImport.update({
    id: '/settings_/form-templates',
    path: '/settings/form-templates',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsCourtTypeStationRoute =
  DashboardSettingsCourtTypeStationRouteImport.update({
    id: '/settings_/court-type-station',
    path: '/settings/court-type-station',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsCourtTypeRoute =
  DashboardSettingsCourtTypeRouteImport.update({
    id: '/settings_/court-type',
    path: '/settings/court-type',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsCourtLevelRoute =
  DashboardSettingsCourtLevelRouteImport.update({
    id: '/settings_/court-level',
    path: '/settings/court-level',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsCaseTypeRoute =
  DashboardSettingsCaseTypeRouteImport.update({
    id: '/settings_/case-type',
    path: '/settings/case-type',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsCaseStagesRoute =
  DashboardSettingsCaseStagesRouteImport.update({
    id: '/settings_/case-stages',
    path: '/settings/case-stages',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsCaseCategoryRoute =
  DashboardSettingsCaseCategoryRouteImport.update({
    id: '/settings_/case-category',
    path: '/settings/case-category',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsBranchRoute = DashboardSettingsBranchRouteImport.update({
  id: '/settings_/branch',
  path: '/settings/branch',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsArticleCategoriesRoute =
  DashboardSettingsArticleCategoriesRouteImport.update({
    id: '/settings_/article-categories',
    path: '/settings/article-categories',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardServingServingIdRoute =
  DashboardServingServingIdRouteImport.update({
    id: '/serving_/$servingId',
    path: '/serving/$servingId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardProfileProfileIdRoute =
  DashboardProfileProfileIdRouteImport.update({
    id: '/profile_/$profileId',
    path: '/profile/$profileId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardHelpTopicsCreateRoute =
  DashboardHelpTopicsCreateRouteImport.update({
    id: '/help-topics_/create',
    path: '/help-topics/create',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardHelpTopicsTopicIdRoute =
  DashboardHelpTopicsTopicIdRouteImport.update({
    id: '/help-topics_/$topicId',
    path: '/help-topics/$topicId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardFormTemplatesFormIdRoute =
  DashboardFormTemplatesFormIdRouteImport.update({
    id: '/form-templates_/$formId',
    path: '/form-templates/$formId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCasesCaseIdRoute = DashboardCasesCaseIdRouteImport.update({
  id: '/cases_/$caseId',
  path: '/cases/$caseId',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCaseProcessingCaseIdRoute =
  DashboardCaseProcessingCaseIdRouteImport.update({
    id: '/case-processing_/$caseId',
    path: '/case-processing/$caseId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCalendarSelectedDateRoute =
  DashboardCalendarSelectedDateRouteImport.update({
    id: '/calendar_/selectedDate',
    path: '/calendar/selectedDate',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardBranchBranchIdRoute = DashboardBranchBranchIdRouteImport.update({
  id: '/branch_/$branchId',
  path: '/branch/$branchId',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardArticlesCreateRoute = DashboardArticlesCreateRouteImport.update({
  id: '/articles_/create',
  path: '/articles/create',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardArticlesArticleIdRoute =
  DashboardArticlesArticleIdRouteImport.update({
    id: '/articles_/$articleId',
    path: '/articles/$articleId',
    getParentRoute: () => DashboardRoute,
  } as any)
const BackofficeCasePaymentsCaseIdRoute =
  BackofficeCasePaymentsCaseIdRouteImport.update({
    id: '/case-payments_/$caseId',
    path: '/case-payments/$caseId',
    getParentRoute: () => BackofficeRoute,
  } as any)
const BackofficeCaseFilingsCreateRoute =
  BackofficeCaseFilingsCreateRouteImport.update({
    id: '/case-filings_/create',
    path: '/case-filings/create',
    getParentRoute: () => BackofficeRoute,
  } as any)
const BackofficeCaseFilingsCaseIdRoute =
  BackofficeCaseFilingsCaseIdRouteImport.update({
    id: '/case-filings_/$caseId',
    path: '/case-filings/$caseId',
    getParentRoute: () => BackofficeRoute,
  } as any)
const BackofficeCaseEvaluationCreateRoute =
  BackofficeCaseEvaluationCreateRouteImport.update({
    id: '/case-evaluation_/create',
    path: '/case-evaluation/create',
    getParentRoute: () => BackofficeRoute,
  } as any)
const BackofficeCaseEvaluationCaseEvaluationIdRoute =
  BackofficeCaseEvaluationCaseEvaluationIdRouteImport.update({
    id: '/case-evaluation_/$caseEvaluationId',
    path: '/case-evaluation/$caseEvaluationId',
    getParentRoute: () => BackofficeRoute,
  } as any)
const BackofficeCaseClassificationCreateRoute =
  BackofficeCaseClassificationCreateRouteImport.update({
    id: '/case-classification_/create',
    path: '/case-classification/create',
    getParentRoute: () => BackofficeRoute,
  } as any)
const BackofficeCaseClassificationCaseClassificationIdRoute =
  BackofficeCaseClassificationCaseClassificationIdRouteImport.update({
    id: '/case-classification_/$caseClassificationId',
    path: '/case-classification/$caseClassificationId',
    getParentRoute: () => BackofficeRoute,
  } as any)
const DashboardUserUserIdEditRoute = DashboardUserUserIdEditRouteImport.update({
  id: '/user_/$userId/edit',
  path: '/user/$userId/edit',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsFormTemplatesCreateRoute =
  DashboardSettingsFormTemplatesCreateRouteImport.update({
    id: '/settings_/form-templates_/create',
    path: '/settings/form-templates/create',
    getParentRoute: () => DashboardRoute,
  } as any)
const BackofficeRaffleCreateCaseIdRoute =
  BackofficeRaffleCreateCaseIdRouteImport.update({
    id: '/raffle_/create_/$caseId',
    path: '/raffle/create/$caseId',
    getParentRoute: () => BackofficeRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/case-filing': typeof CaseFilingRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/help-center': typeof HelpCenterRoute
  '/help-center2': typeof HelpCenter2Route
  '/help-guides': typeof HelpGuidesRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/sentry-error-test': typeof SentryErrorTestRoute
  '/branch-statistics': typeof BackofficeBranchStatisticsRoute
  '/case-classification': typeof BackofficeCaseClassificationRoute
  '/case-evaluation': typeof BackofficeCaseEvaluationRoute
  '/new-cases': typeof BackofficeNewCasesRoute
  '/public-profile': typeof BackofficePublicProfileRoute
  '/raffle': typeof BackofficeRaffleRoute
  '/report-statistic': typeof BackofficeReportStatisticRoute
  '/serving': typeof BackofficeServingRoute
  '/sheriff-reports': typeof BackofficeSheriffReportsRoute
  '/statistics': typeof BackofficeStatisticsRoute
  '/stenographic-notes': typeof BackofficeStenographicNotesRoute
  '/articles': typeof DashboardArticlesRoute
  '/bcc-dashboard': typeof DashboardBccDashboardRoute
  '/calendar': typeof DashboardCalendarRoute
  '/calendar-of-events': typeof DashboardCalendarOfEventsRoute
  '/case-processing': typeof DashboardCaseProcessingRoute
  '/cases': typeof DashboardCasesRoute
  '/changelogs': typeof DashboardChangelogsRoute
  '/form-templates': typeof DashboardFormTemplatesRoute
  '/help': typeof DashboardHelpRoute
  '/help-topics': typeof DashboardHelpTopicsRoute
  '/judge-dashboard': typeof DashboardJudgeDashboardRoute
  '/notifications': typeof DashboardNotificationsRoute
  '/occ-dashboard': typeof DashboardOccDashboardRoute
  '/profile': typeof DashboardProfileRoute
  '/settings': typeof DashboardSettingsRoute
  '/text-editor': typeof DashboardTextEditorRoute
  '/tibol': typeof DashboardTibolRoute
  '/users': typeof DashboardUsersRoute
  '/email/verify': typeof EmailVerifyRoute
  '/settings/active-user-sessions': typeof SettingsActiveUserSessionsRoute
  '/settings/case-activity-settings': typeof SettingsCaseActivitySettingsRoute
  '/': typeof DashboardIndexRoute
  '/case-classification/$caseClassificationId': typeof BackofficeCaseClassificationCaseClassificationIdRoute
  '/case-classification/create': typeof BackofficeCaseClassificationCreateRoute
  '/case-evaluation/$caseEvaluationId': typeof BackofficeCaseEvaluationCaseEvaluationIdRoute
  '/case-evaluation/create': typeof BackofficeCaseEvaluationCreateRoute
  '/case-filings/$caseId': typeof BackofficeCaseFilingsCaseIdRoute
  '/case-filings/create': typeof BackofficeCaseFilingsCreateRoute
  '/case-payments/$caseId': typeof BackofficeCasePaymentsCaseIdRoute
  '/articles/$articleId': typeof DashboardArticlesArticleIdRoute
  '/articles/create': typeof DashboardArticlesCreateRoute
  '/branch/$branchId': typeof DashboardBranchBranchIdRoute
  '/calendar/selectedDate': typeof DashboardCalendarSelectedDateRoute
  '/case-processing/$caseId': typeof DashboardCaseProcessingCaseIdRoute
  '/cases/$caseId': typeof DashboardCasesCaseIdRoute
  '/form-templates/$formId': typeof DashboardFormTemplatesFormIdRoute
  '/help-topics/$topicId': typeof DashboardHelpTopicsTopicIdRoute
  '/help-topics/create': typeof DashboardHelpTopicsCreateRoute
  '/profile/$profileId': typeof DashboardProfileProfileIdRoute
  '/serving/$servingId': typeof DashboardServingServingIdRoute
  '/settings/article-categories': typeof DashboardSettingsArticleCategoriesRoute
  '/settings/branch': typeof DashboardSettingsBranchRoute
  '/settings/case-category': typeof DashboardSettingsCaseCategoryRoute
  '/settings/case-stages': typeof DashboardSettingsCaseStagesRoute
  '/settings/case-type': typeof DashboardSettingsCaseTypeRoute
  '/settings/court-level': typeof DashboardSettingsCourtLevelRoute
  '/settings/court-type': typeof DashboardSettingsCourtTypeRoute
  '/settings/court-type-station': typeof DashboardSettingsCourtTypeStationRoute
  '/settings/form-templates': typeof DashboardSettingsFormTemplatesRoute
  '/settings/help-categories': typeof DashboardSettingsHelpCategoriesRoute
  '/settings/keywords': typeof DashboardSettingsKeywordsRoute
  '/settings/province': typeof DashboardSettingsProvinceRoute
  '/settings/region': typeof DashboardSettingsRegionRoute
  '/settings/roles': typeof DashboardSettingsRolesRoute
  '/settings/user-audit-logs': typeof DashboardSettingsUserAuditLogsRoute
  '/user/create': typeof DashboardUserCreateRoute
  '/users/$userId': typeof DashboardUsersUserIdRoute
  '/case-filings': typeof BackofficeCaseFilingsIndexRoute
  '/raffle/create/$caseId': typeof BackofficeRaffleCreateCaseIdRoute
  '/settings/form-templates/create': typeof DashboardSettingsFormTemplatesCreateRoute
  '/user/$userId/edit': typeof DashboardUserUserIdEditRoute
}
export interface FileRoutesByTo {
  '/case-filing': typeof CaseFilingRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/help-center': typeof HelpCenterRoute
  '/help-center2': typeof HelpCenter2Route
  '/help-guides': typeof HelpGuidesRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/sentry-error-test': typeof SentryErrorTestRoute
  '/branch-statistics': typeof BackofficeBranchStatisticsRoute
  '/case-classification': typeof BackofficeCaseClassificationRoute
  '/case-evaluation': typeof BackofficeCaseEvaluationRoute
  '/new-cases': typeof BackofficeNewCasesRoute
  '/public-profile': typeof BackofficePublicProfileRoute
  '/raffle': typeof BackofficeRaffleRoute
  '/report-statistic': typeof BackofficeReportStatisticRoute
  '/serving': typeof BackofficeServingRoute
  '/sheriff-reports': typeof BackofficeSheriffReportsRoute
  '/statistics': typeof BackofficeStatisticsRoute
  '/stenographic-notes': typeof BackofficeStenographicNotesRoute
  '/articles': typeof DashboardArticlesRoute
  '/bcc-dashboard': typeof DashboardBccDashboardRoute
  '/calendar': typeof DashboardCalendarRoute
  '/calendar-of-events': typeof DashboardCalendarOfEventsRoute
  '/case-processing': typeof DashboardCaseProcessingRoute
  '/cases': typeof DashboardCasesRoute
  '/changelogs': typeof DashboardChangelogsRoute
  '/form-templates': typeof DashboardFormTemplatesRoute
  '/help': typeof DashboardHelpRoute
  '/help-topics': typeof DashboardHelpTopicsRoute
  '/judge-dashboard': typeof DashboardJudgeDashboardRoute
  '/notifications': typeof DashboardNotificationsRoute
  '/occ-dashboard': typeof DashboardOccDashboardRoute
  '/profile': typeof DashboardProfileRoute
  '/settings': typeof DashboardSettingsRoute
  '/text-editor': typeof DashboardTextEditorRoute
  '/tibol': typeof DashboardTibolRoute
  '/users': typeof DashboardUsersRoute
  '/email/verify': typeof EmailVerifyRoute
  '/settings/active-user-sessions': typeof SettingsActiveUserSessionsRoute
  '/settings/case-activity-settings': typeof SettingsCaseActivitySettingsRoute
  '/': typeof DashboardIndexRoute
  '/case-classification/$caseClassificationId': typeof BackofficeCaseClassificationCaseClassificationIdRoute
  '/case-classification/create': typeof BackofficeCaseClassificationCreateRoute
  '/case-evaluation/$caseEvaluationId': typeof BackofficeCaseEvaluationCaseEvaluationIdRoute
  '/case-evaluation/create': typeof BackofficeCaseEvaluationCreateRoute
  '/case-filings/$caseId': typeof BackofficeCaseFilingsCaseIdRoute
  '/case-filings/create': typeof BackofficeCaseFilingsCreateRoute
  '/case-payments/$caseId': typeof BackofficeCasePaymentsCaseIdRoute
  '/articles/$articleId': typeof DashboardArticlesArticleIdRoute
  '/articles/create': typeof DashboardArticlesCreateRoute
  '/branch/$branchId': typeof DashboardBranchBranchIdRoute
  '/calendar/selectedDate': typeof DashboardCalendarSelectedDateRoute
  '/case-processing/$caseId': typeof DashboardCaseProcessingCaseIdRoute
  '/cases/$caseId': typeof DashboardCasesCaseIdRoute
  '/form-templates/$formId': typeof DashboardFormTemplatesFormIdRoute
  '/help-topics/$topicId': typeof DashboardHelpTopicsTopicIdRoute
  '/help-topics/create': typeof DashboardHelpTopicsCreateRoute
  '/profile/$profileId': typeof DashboardProfileProfileIdRoute
  '/serving/$servingId': typeof DashboardServingServingIdRoute
  '/settings/article-categories': typeof DashboardSettingsArticleCategoriesRoute
  '/settings/branch': typeof DashboardSettingsBranchRoute
  '/settings/case-category': typeof DashboardSettingsCaseCategoryRoute
  '/settings/case-stages': typeof DashboardSettingsCaseStagesRoute
  '/settings/case-type': typeof DashboardSettingsCaseTypeRoute
  '/settings/court-level': typeof DashboardSettingsCourtLevelRoute
  '/settings/court-type': typeof DashboardSettingsCourtTypeRoute
  '/settings/court-type-station': typeof DashboardSettingsCourtTypeStationRoute
  '/settings/form-templates': typeof DashboardSettingsFormTemplatesRoute
  '/settings/help-categories': typeof DashboardSettingsHelpCategoriesRoute
  '/settings/keywords': typeof DashboardSettingsKeywordsRoute
  '/settings/province': typeof DashboardSettingsProvinceRoute
  '/settings/region': typeof DashboardSettingsRegionRoute
  '/settings/roles': typeof DashboardSettingsRolesRoute
  '/settings/user-audit-logs': typeof DashboardSettingsUserAuditLogsRoute
  '/user/create': typeof DashboardUserCreateRoute
  '/users/$userId': typeof DashboardUsersUserIdRoute
  '/case-filings': typeof BackofficeCaseFilingsIndexRoute
  '/raffle/create/$caseId': typeof BackofficeRaffleCreateCaseIdRoute
  '/settings/form-templates/create': typeof DashboardSettingsFormTemplatesCreateRoute
  '/user/$userId/edit': typeof DashboardUserUserIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_backoffice': typeof BackofficeRouteWithChildren
  '/_dashboard': typeof DashboardRouteWithChildren
  '/case-filing': typeof CaseFilingRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/help-center': typeof HelpCenterRoute
  '/help-center2': typeof HelpCenter2Route
  '/help-guides': typeof HelpGuidesRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/sentry-error-test': typeof SentryErrorTestRoute
  '/_backoffice/branch-statistics': typeof BackofficeBranchStatisticsRoute
  '/_backoffice/case-classification': typeof BackofficeCaseClassificationRoute
  '/_backoffice/case-evaluation': typeof BackofficeCaseEvaluationRoute
  '/_backoffice/new-cases': typeof BackofficeNewCasesRoute
  '/_backoffice/public-profile': typeof BackofficePublicProfileRoute
  '/_backoffice/raffle': typeof BackofficeRaffleRoute
  '/_backoffice/report-statistic': typeof BackofficeReportStatisticRoute
  '/_backoffice/serving': typeof BackofficeServingRoute
  '/_backoffice/sheriff-reports': typeof BackofficeSheriffReportsRoute
  '/_backoffice/statistics': typeof BackofficeStatisticsRoute
  '/_backoffice/stenographic-notes': typeof BackofficeStenographicNotesRoute
  '/_dashboard/articles': typeof DashboardArticlesRoute
  '/_dashboard/bcc-dashboard': typeof DashboardBccDashboardRoute
  '/_dashboard/calendar': typeof DashboardCalendarRoute
  '/_dashboard/calendar-of-events': typeof DashboardCalendarOfEventsRoute
  '/_dashboard/case-processing': typeof DashboardCaseProcessingRoute
  '/_dashboard/cases': typeof DashboardCasesRoute
  '/_dashboard/changelogs': typeof DashboardChangelogsRoute
  '/_dashboard/form-templates': typeof DashboardFormTemplatesRoute
  '/_dashboard/help': typeof DashboardHelpRoute
  '/_dashboard/help-topics': typeof DashboardHelpTopicsRoute
  '/_dashboard/judge-dashboard': typeof DashboardJudgeDashboardRoute
  '/_dashboard/notifications': typeof DashboardNotificationsRoute
  '/_dashboard/occ-dashboard': typeof DashboardOccDashboardRoute
  '/_dashboard/profile': typeof DashboardProfileRoute
  '/_dashboard/settings': typeof DashboardSettingsRoute
  '/_dashboard/text-editor': typeof DashboardTextEditorRoute
  '/_dashboard/tibol': typeof DashboardTibolRoute
  '/_dashboard/users': typeof DashboardUsersRoute
  '/email/verify': typeof EmailVerifyRoute
  '/settings/active-user-sessions': typeof SettingsActiveUserSessionsRoute
  '/settings/case-activity-settings': typeof SettingsCaseActivitySettingsRoute
  '/_dashboard/': typeof DashboardIndexRoute
  '/_backoffice/case-classification_/$caseClassificationId': typeof BackofficeCaseClassificationCaseClassificationIdRoute
  '/_backoffice/case-classification_/create': typeof BackofficeCaseClassificationCreateRoute
  '/_backoffice/case-evaluation_/$caseEvaluationId': typeof BackofficeCaseEvaluationCaseEvaluationIdRoute
  '/_backoffice/case-evaluation_/create': typeof BackofficeCaseEvaluationCreateRoute
  '/_backoffice/case-filings_/$caseId': typeof BackofficeCaseFilingsCaseIdRoute
  '/_backoffice/case-filings_/create': typeof BackofficeCaseFilingsCreateRoute
  '/_backoffice/case-payments_/$caseId': typeof BackofficeCasePaymentsCaseIdRoute
  '/_dashboard/articles_/$articleId': typeof DashboardArticlesArticleIdRoute
  '/_dashboard/articles_/create': typeof DashboardArticlesCreateRoute
  '/_dashboard/branch_/$branchId': typeof DashboardBranchBranchIdRoute
  '/_dashboard/calendar_/selectedDate': typeof DashboardCalendarSelectedDateRoute
  '/_dashboard/case-processing_/$caseId': typeof DashboardCaseProcessingCaseIdRoute
  '/_dashboard/cases_/$caseId': typeof DashboardCasesCaseIdRoute
  '/_dashboard/form-templates_/$formId': typeof DashboardFormTemplatesFormIdRoute
  '/_dashboard/help-topics_/$topicId': typeof DashboardHelpTopicsTopicIdRoute
  '/_dashboard/help-topics_/create': typeof DashboardHelpTopicsCreateRoute
  '/_dashboard/profile_/$profileId': typeof DashboardProfileProfileIdRoute
  '/_dashboard/serving_/$servingId': typeof DashboardServingServingIdRoute
  '/_dashboard/settings_/article-categories': typeof DashboardSettingsArticleCategoriesRoute
  '/_dashboard/settings_/branch': typeof DashboardSettingsBranchRoute
  '/_dashboard/settings_/case-category': typeof DashboardSettingsCaseCategoryRoute
  '/_dashboard/settings_/case-stages': typeof DashboardSettingsCaseStagesRoute
  '/_dashboard/settings_/case-type': typeof DashboardSettingsCaseTypeRoute
  '/_dashboard/settings_/court-level': typeof DashboardSettingsCourtLevelRoute
  '/_dashboard/settings_/court-type': typeof DashboardSettingsCourtTypeRoute
  '/_dashboard/settings_/court-type-station': typeof DashboardSettingsCourtTypeStationRoute
  '/_dashboard/settings_/form-templates': typeof DashboardSettingsFormTemplatesRoute
  '/_dashboard/settings_/help-categories': typeof DashboardSettingsHelpCategoriesRoute
  '/_dashboard/settings_/keywords': typeof DashboardSettingsKeywordsRoute
  '/_dashboard/settings_/province': typeof DashboardSettingsProvinceRoute
  '/_dashboard/settings_/region': typeof DashboardSettingsRegionRoute
  '/_dashboard/settings_/roles': typeof DashboardSettingsRolesRoute
  '/_dashboard/settings_/user-audit-logs': typeof DashboardSettingsUserAuditLogsRoute
  '/_dashboard/user/create': typeof DashboardUserCreateRoute
  '/_dashboard/users_/$userId': typeof DashboardUsersUserIdRoute
  '/_backoffice/case-filings_/': typeof BackofficeCaseFilingsIndexRoute
  '/_backoffice/raffle_/create_/$caseId': typeof BackofficeRaffleCreateCaseIdRoute
  '/_dashboard/settings_/form-templates_/create': typeof DashboardSettingsFormTemplatesCreateRoute
  '/_dashboard/user_/$userId/edit': typeof DashboardUserUserIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/case-filing'
    | '/forgot-password'
    | '/help-center'
    | '/help-center2'
    | '/help-guides'
    | '/login'
    | '/register'
    | '/sentry-error-test'
    | '/branch-statistics'
    | '/case-classification'
    | '/case-evaluation'
    | '/new-cases'
    | '/public-profile'
    | '/raffle'
    | '/report-statistic'
    | '/serving'
    | '/sheriff-reports'
    | '/statistics'
    | '/stenographic-notes'
    | '/articles'
    | '/bcc-dashboard'
    | '/calendar'
    | '/calendar-of-events'
    | '/case-processing'
    | '/cases'
    | '/changelogs'
    | '/form-templates'
    | '/help'
    | '/help-topics'
    | '/judge-dashboard'
    | '/notifications'
    | '/occ-dashboard'
    | '/profile'
    | '/settings'
    | '/text-editor'
    | '/tibol'
    | '/users'
    | '/email/verify'
    | '/settings/active-user-sessions'
    | '/settings/case-activity-settings'
    | '/'
    | '/case-classification/$caseClassificationId'
    | '/case-classification/create'
    | '/case-evaluation/$caseEvaluationId'
    | '/case-evaluation/create'
    | '/case-filings/$caseId'
    | '/case-filings/create'
    | '/case-payments/$caseId'
    | '/articles/$articleId'
    | '/articles/create'
    | '/branch/$branchId'
    | '/calendar/selectedDate'
    | '/case-processing/$caseId'
    | '/cases/$caseId'
    | '/form-templates/$formId'
    | '/help-topics/$topicId'
    | '/help-topics/create'
    | '/profile/$profileId'
    | '/serving/$servingId'
    | '/settings/article-categories'
    | '/settings/branch'
    | '/settings/case-category'
    | '/settings/case-stages'
    | '/settings/case-type'
    | '/settings/court-level'
    | '/settings/court-type'
    | '/settings/court-type-station'
    | '/settings/form-templates'
    | '/settings/help-categories'
    | '/settings/keywords'
    | '/settings/province'
    | '/settings/region'
    | '/settings/roles'
    | '/settings/user-audit-logs'
    | '/user/create'
    | '/users/$userId'
    | '/case-filings'
    | '/raffle/create/$caseId'
    | '/settings/form-templates/create'
    | '/user/$userId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/case-filing'
    | '/forgot-password'
    | '/help-center'
    | '/help-center2'
    | '/help-guides'
    | '/login'
    | '/register'
    | '/sentry-error-test'
    | '/branch-statistics'
    | '/case-classification'
    | '/case-evaluation'
    | '/new-cases'
    | '/public-profile'
    | '/raffle'
    | '/report-statistic'
    | '/serving'
    | '/sheriff-reports'
    | '/statistics'
    | '/stenographic-notes'
    | '/articles'
    | '/bcc-dashboard'
    | '/calendar'
    | '/calendar-of-events'
    | '/case-processing'
    | '/cases'
    | '/changelogs'
    | '/form-templates'
    | '/help'
    | '/help-topics'
    | '/judge-dashboard'
    | '/notifications'
    | '/occ-dashboard'
    | '/profile'
    | '/settings'
    | '/text-editor'
    | '/tibol'
    | '/users'
    | '/email/verify'
    | '/settings/active-user-sessions'
    | '/settings/case-activity-settings'
    | '/'
    | '/case-classification/$caseClassificationId'
    | '/case-classification/create'
    | '/case-evaluation/$caseEvaluationId'
    | '/case-evaluation/create'
    | '/case-filings/$caseId'
    | '/case-filings/create'
    | '/case-payments/$caseId'
    | '/articles/$articleId'
    | '/articles/create'
    | '/branch/$branchId'
    | '/calendar/selectedDate'
    | '/case-processing/$caseId'
    | '/cases/$caseId'
    | '/form-templates/$formId'
    | '/help-topics/$topicId'
    | '/help-topics/create'
    | '/profile/$profileId'
    | '/serving/$servingId'
    | '/settings/article-categories'
    | '/settings/branch'
    | '/settings/case-category'
    | '/settings/case-stages'
    | '/settings/case-type'
    | '/settings/court-level'
    | '/settings/court-type'
    | '/settings/court-type-station'
    | '/settings/form-templates'
    | '/settings/help-categories'
    | '/settings/keywords'
    | '/settings/province'
    | '/settings/region'
    | '/settings/roles'
    | '/settings/user-audit-logs'
    | '/user/create'
    | '/users/$userId'
    | '/case-filings'
    | '/raffle/create/$caseId'
    | '/settings/form-templates/create'
    | '/user/$userId/edit'
  id:
    | '__root__'
    | '/_backoffice'
    | '/_dashboard'
    | '/case-filing'
    | '/forgot-password'
    | '/help-center'
    | '/help-center2'
    | '/help-guides'
    | '/login'
    | '/register'
    | '/sentry-error-test'
    | '/_backoffice/branch-statistics'
    | '/_backoffice/case-classification'
    | '/_backoffice/case-evaluation'
    | '/_backoffice/new-cases'
    | '/_backoffice/public-profile'
    | '/_backoffice/raffle'
    | '/_backoffice/report-statistic'
    | '/_backoffice/serving'
    | '/_backoffice/sheriff-reports'
    | '/_backoffice/statistics'
    | '/_backoffice/stenographic-notes'
    | '/_dashboard/articles'
    | '/_dashboard/bcc-dashboard'
    | '/_dashboard/calendar'
    | '/_dashboard/calendar-of-events'
    | '/_dashboard/case-processing'
    | '/_dashboard/cases'
    | '/_dashboard/changelogs'
    | '/_dashboard/form-templates'
    | '/_dashboard/help'
    | '/_dashboard/help-topics'
    | '/_dashboard/judge-dashboard'
    | '/_dashboard/notifications'
    | '/_dashboard/occ-dashboard'
    | '/_dashboard/profile'
    | '/_dashboard/settings'
    | '/_dashboard/text-editor'
    | '/_dashboard/tibol'
    | '/_dashboard/users'
    | '/email/verify'
    | '/settings/active-user-sessions'
    | '/settings/case-activity-settings'
    | '/_dashboard/'
    | '/_backoffice/case-classification_/$caseClassificationId'
    | '/_backoffice/case-classification_/create'
    | '/_backoffice/case-evaluation_/$caseEvaluationId'
    | '/_backoffice/case-evaluation_/create'
    | '/_backoffice/case-filings_/$caseId'
    | '/_backoffice/case-filings_/create'
    | '/_backoffice/case-payments_/$caseId'
    | '/_dashboard/articles_/$articleId'
    | '/_dashboard/articles_/create'
    | '/_dashboard/branch_/$branchId'
    | '/_dashboard/calendar_/selectedDate'
    | '/_dashboard/case-processing_/$caseId'
    | '/_dashboard/cases_/$caseId'
    | '/_dashboard/form-templates_/$formId'
    | '/_dashboard/help-topics_/$topicId'
    | '/_dashboard/help-topics_/create'
    | '/_dashboard/profile_/$profileId'
    | '/_dashboard/serving_/$servingId'
    | '/_dashboard/settings_/article-categories'
    | '/_dashboard/settings_/branch'
    | '/_dashboard/settings_/case-category'
    | '/_dashboard/settings_/case-stages'
    | '/_dashboard/settings_/case-type'
    | '/_dashboard/settings_/court-level'
    | '/_dashboard/settings_/court-type'
    | '/_dashboard/settings_/court-type-station'
    | '/_dashboard/settings_/form-templates'
    | '/_dashboard/settings_/help-categories'
    | '/_dashboard/settings_/keywords'
    | '/_dashboard/settings_/province'
    | '/_dashboard/settings_/region'
    | '/_dashboard/settings_/roles'
    | '/_dashboard/settings_/user-audit-logs'
    | '/_dashboard/user/create'
    | '/_dashboard/users_/$userId'
    | '/_backoffice/case-filings_/'
    | '/_backoffice/raffle_/create_/$caseId'
    | '/_dashboard/settings_/form-templates_/create'
    | '/_dashboard/user_/$userId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  BackofficeRoute: typeof BackofficeRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
  CaseFilingRoute: typeof CaseFilingRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  HelpCenterRoute: typeof HelpCenterRoute
  HelpCenter2Route: typeof HelpCenter2Route
  HelpGuidesRoute: typeof HelpGuidesRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  SentryErrorTestRoute: typeof SentryErrorTestRoute
  EmailVerifyRoute: typeof EmailVerifyRoute
  SettingsActiveUserSessionsRoute: typeof SettingsActiveUserSessionsRoute
  SettingsCaseActivitySettingsRoute: typeof SettingsCaseActivitySettingsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sentry-error-test': {
      id: '/sentry-error-test'
      path: '/sentry-error-test'
      fullPath: '/sentry-error-test'
      preLoaderRoute: typeof SentryErrorTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help-guides': {
      id: '/help-guides'
      path: '/help-guides'
      fullPath: '/help-guides'
      preLoaderRoute: typeof HelpGuidesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help-center2': {
      id: '/help-center2'
      path: '/help-center2'
      fullPath: '/help-center2'
      preLoaderRoute: typeof HelpCenter2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help-center': {
      id: '/help-center'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof HelpCenterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/case-filing': {
      id: '/case-filing'
      path: '/case-filing'
      fullPath: '/case-filing'
      preLoaderRoute: typeof CaseFilingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_backoffice': {
      id: '/_backoffice'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof BackofficeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/settings/case-activity-settings': {
      id: '/settings/case-activity-settings'
      path: '/settings/case-activity-settings'
      fullPath: '/settings/case-activity-settings'
      preLoaderRoute: typeof SettingsCaseActivitySettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/active-user-sessions': {
      id: '/settings/active-user-sessions'
      path: '/settings/active-user-sessions'
      fullPath: '/settings/active-user-sessions'
      preLoaderRoute: typeof SettingsActiveUserSessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email/verify': {
      id: '/email/verify'
      path: '/email/verify'
      fullPath: '/email/verify'
      preLoaderRoute: typeof EmailVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/users': {
      id: '/_dashboard/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof DashboardUsersRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/tibol': {
      id: '/_dashboard/tibol'
      path: '/tibol'
      fullPath: '/tibol'
      preLoaderRoute: typeof DashboardTibolRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/text-editor': {
      id: '/_dashboard/text-editor'
      path: '/text-editor'
      fullPath: '/text-editor'
      preLoaderRoute: typeof DashboardTextEditorRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings': {
      id: '/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/profile': {
      id: '/_dashboard/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof DashboardProfileRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/occ-dashboard': {
      id: '/_dashboard/occ-dashboard'
      path: '/occ-dashboard'
      fullPath: '/occ-dashboard'
      preLoaderRoute: typeof DashboardOccDashboardRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/notifications': {
      id: '/_dashboard/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof DashboardNotificationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/judge-dashboard': {
      id: '/_dashboard/judge-dashboard'
      path: '/judge-dashboard'
      fullPath: '/judge-dashboard'
      preLoaderRoute: typeof DashboardJudgeDashboardRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/help-topics': {
      id: '/_dashboard/help-topics'
      path: '/help-topics'
      fullPath: '/help-topics'
      preLoaderRoute: typeof DashboardHelpTopicsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/help': {
      id: '/_dashboard/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof DashboardHelpRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/form-templates': {
      id: '/_dashboard/form-templates'
      path: '/form-templates'
      fullPath: '/form-templates'
      preLoaderRoute: typeof DashboardFormTemplatesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/changelogs': {
      id: '/_dashboard/changelogs'
      path: '/changelogs'
      fullPath: '/changelogs'
      preLoaderRoute: typeof DashboardChangelogsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/cases': {
      id: '/_dashboard/cases'
      path: '/cases'
      fullPath: '/cases'
      preLoaderRoute: typeof DashboardCasesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/case-processing': {
      id: '/_dashboard/case-processing'
      path: '/case-processing'
      fullPath: '/case-processing'
      preLoaderRoute: typeof DashboardCaseProcessingRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/calendar-of-events': {
      id: '/_dashboard/calendar-of-events'
      path: '/calendar-of-events'
      fullPath: '/calendar-of-events'
      preLoaderRoute: typeof DashboardCalendarOfEventsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/calendar': {
      id: '/_dashboard/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof DashboardCalendarRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/bcc-dashboard': {
      id: '/_dashboard/bcc-dashboard'
      path: '/bcc-dashboard'
      fullPath: '/bcc-dashboard'
      preLoaderRoute: typeof DashboardBccDashboardRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/articles': {
      id: '/_dashboard/articles'
      path: '/articles'
      fullPath: '/articles'
      preLoaderRoute: typeof DashboardArticlesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_backoffice/stenographic-notes': {
      id: '/_backoffice/stenographic-notes'
      path: '/stenographic-notes'
      fullPath: '/stenographic-notes'
      preLoaderRoute: typeof BackofficeStenographicNotesRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/statistics': {
      id: '/_backoffice/statistics'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof BackofficeStatisticsRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/sheriff-reports': {
      id: '/_backoffice/sheriff-reports'
      path: '/sheriff-reports'
      fullPath: '/sheriff-reports'
      preLoaderRoute: typeof BackofficeSheriffReportsRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/serving': {
      id: '/_backoffice/serving'
      path: '/serving'
      fullPath: '/serving'
      preLoaderRoute: typeof BackofficeServingRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/report-statistic': {
      id: '/_backoffice/report-statistic'
      path: '/report-statistic'
      fullPath: '/report-statistic'
      preLoaderRoute: typeof BackofficeReportStatisticRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/raffle': {
      id: '/_backoffice/raffle'
      path: '/raffle'
      fullPath: '/raffle'
      preLoaderRoute: typeof BackofficeRaffleRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/public-profile': {
      id: '/_backoffice/public-profile'
      path: '/public-profile'
      fullPath: '/public-profile'
      preLoaderRoute: typeof BackofficePublicProfileRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/new-cases': {
      id: '/_backoffice/new-cases'
      path: '/new-cases'
      fullPath: '/new-cases'
      preLoaderRoute: typeof BackofficeNewCasesRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/case-evaluation': {
      id: '/_backoffice/case-evaluation'
      path: '/case-evaluation'
      fullPath: '/case-evaluation'
      preLoaderRoute: typeof BackofficeCaseEvaluationRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/case-classification': {
      id: '/_backoffice/case-classification'
      path: '/case-classification'
      fullPath: '/case-classification'
      preLoaderRoute: typeof BackofficeCaseClassificationRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/branch-statistics': {
      id: '/_backoffice/branch-statistics'
      path: '/branch-statistics'
      fullPath: '/branch-statistics'
      preLoaderRoute: typeof BackofficeBranchStatisticsRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/case-filings_/': {
      id: '/_backoffice/case-filings_/'
      path: '/case-filings'
      fullPath: '/case-filings'
      preLoaderRoute: typeof BackofficeCaseFilingsIndexRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_dashboard/users_/$userId': {
      id: '/_dashboard/users_/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof DashboardUsersUserIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/user/create': {
      id: '/_dashboard/user/create'
      path: '/user/create'
      fullPath: '/user/create'
      preLoaderRoute: typeof DashboardUserCreateRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/user-audit-logs': {
      id: '/_dashboard/settings_/user-audit-logs'
      path: '/settings/user-audit-logs'
      fullPath: '/settings/user-audit-logs'
      preLoaderRoute: typeof DashboardSettingsUserAuditLogsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/roles': {
      id: '/_dashboard/settings_/roles'
      path: '/settings/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof DashboardSettingsRolesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/region': {
      id: '/_dashboard/settings_/region'
      path: '/settings/region'
      fullPath: '/settings/region'
      preLoaderRoute: typeof DashboardSettingsRegionRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/province': {
      id: '/_dashboard/settings_/province'
      path: '/settings/province'
      fullPath: '/settings/province'
      preLoaderRoute: typeof DashboardSettingsProvinceRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/keywords': {
      id: '/_dashboard/settings_/keywords'
      path: '/settings/keywords'
      fullPath: '/settings/keywords'
      preLoaderRoute: typeof DashboardSettingsKeywordsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/help-categories': {
      id: '/_dashboard/settings_/help-categories'
      path: '/settings/help-categories'
      fullPath: '/settings/help-categories'
      preLoaderRoute: typeof DashboardSettingsHelpCategoriesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/form-templates': {
      id: '/_dashboard/settings_/form-templates'
      path: '/settings/form-templates'
      fullPath: '/settings/form-templates'
      preLoaderRoute: typeof DashboardSettingsFormTemplatesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/court-type-station': {
      id: '/_dashboard/settings_/court-type-station'
      path: '/settings/court-type-station'
      fullPath: '/settings/court-type-station'
      preLoaderRoute: typeof DashboardSettingsCourtTypeStationRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/court-type': {
      id: '/_dashboard/settings_/court-type'
      path: '/settings/court-type'
      fullPath: '/settings/court-type'
      preLoaderRoute: typeof DashboardSettingsCourtTypeRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/court-level': {
      id: '/_dashboard/settings_/court-level'
      path: '/settings/court-level'
      fullPath: '/settings/court-level'
      preLoaderRoute: typeof DashboardSettingsCourtLevelRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/case-type': {
      id: '/_dashboard/settings_/case-type'
      path: '/settings/case-type'
      fullPath: '/settings/case-type'
      preLoaderRoute: typeof DashboardSettingsCaseTypeRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/case-stages': {
      id: '/_dashboard/settings_/case-stages'
      path: '/settings/case-stages'
      fullPath: '/settings/case-stages'
      preLoaderRoute: typeof DashboardSettingsCaseStagesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/case-category': {
      id: '/_dashboard/settings_/case-category'
      path: '/settings/case-category'
      fullPath: '/settings/case-category'
      preLoaderRoute: typeof DashboardSettingsCaseCategoryRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/branch': {
      id: '/_dashboard/settings_/branch'
      path: '/settings/branch'
      fullPath: '/settings/branch'
      preLoaderRoute: typeof DashboardSettingsBranchRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/article-categories': {
      id: '/_dashboard/settings_/article-categories'
      path: '/settings/article-categories'
      fullPath: '/settings/article-categories'
      preLoaderRoute: typeof DashboardSettingsArticleCategoriesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/serving_/$servingId': {
      id: '/_dashboard/serving_/$servingId'
      path: '/serving/$servingId'
      fullPath: '/serving/$servingId'
      preLoaderRoute: typeof DashboardServingServingIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/profile_/$profileId': {
      id: '/_dashboard/profile_/$profileId'
      path: '/profile/$profileId'
      fullPath: '/profile/$profileId'
      preLoaderRoute: typeof DashboardProfileProfileIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/help-topics_/create': {
      id: '/_dashboard/help-topics_/create'
      path: '/help-topics/create'
      fullPath: '/help-topics/create'
      preLoaderRoute: typeof DashboardHelpTopicsCreateRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/help-topics_/$topicId': {
      id: '/_dashboard/help-topics_/$topicId'
      path: '/help-topics/$topicId'
      fullPath: '/help-topics/$topicId'
      preLoaderRoute: typeof DashboardHelpTopicsTopicIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/form-templates_/$formId': {
      id: '/_dashboard/form-templates_/$formId'
      path: '/form-templates/$formId'
      fullPath: '/form-templates/$formId'
      preLoaderRoute: typeof DashboardFormTemplatesFormIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/cases_/$caseId': {
      id: '/_dashboard/cases_/$caseId'
      path: '/cases/$caseId'
      fullPath: '/cases/$caseId'
      preLoaderRoute: typeof DashboardCasesCaseIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/case-processing_/$caseId': {
      id: '/_dashboard/case-processing_/$caseId'
      path: '/case-processing/$caseId'
      fullPath: '/case-processing/$caseId'
      preLoaderRoute: typeof DashboardCaseProcessingCaseIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/calendar_/selectedDate': {
      id: '/_dashboard/calendar_/selectedDate'
      path: '/calendar/selectedDate'
      fullPath: '/calendar/selectedDate'
      preLoaderRoute: typeof DashboardCalendarSelectedDateRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/branch_/$branchId': {
      id: '/_dashboard/branch_/$branchId'
      path: '/branch/$branchId'
      fullPath: '/branch/$branchId'
      preLoaderRoute: typeof DashboardBranchBranchIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/articles_/create': {
      id: '/_dashboard/articles_/create'
      path: '/articles/create'
      fullPath: '/articles/create'
      preLoaderRoute: typeof DashboardArticlesCreateRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/articles_/$articleId': {
      id: '/_dashboard/articles_/$articleId'
      path: '/articles/$articleId'
      fullPath: '/articles/$articleId'
      preLoaderRoute: typeof DashboardArticlesArticleIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_backoffice/case-payments_/$caseId': {
      id: '/_backoffice/case-payments_/$caseId'
      path: '/case-payments/$caseId'
      fullPath: '/case-payments/$caseId'
      preLoaderRoute: typeof BackofficeCasePaymentsCaseIdRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/case-filings_/create': {
      id: '/_backoffice/case-filings_/create'
      path: '/case-filings/create'
      fullPath: '/case-filings/create'
      preLoaderRoute: typeof BackofficeCaseFilingsCreateRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/case-filings_/$caseId': {
      id: '/_backoffice/case-filings_/$caseId'
      path: '/case-filings/$caseId'
      fullPath: '/case-filings/$caseId'
      preLoaderRoute: typeof BackofficeCaseFilingsCaseIdRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/case-evaluation_/create': {
      id: '/_backoffice/case-evaluation_/create'
      path: '/case-evaluation/create'
      fullPath: '/case-evaluation/create'
      preLoaderRoute: typeof BackofficeCaseEvaluationCreateRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/case-evaluation_/$caseEvaluationId': {
      id: '/_backoffice/case-evaluation_/$caseEvaluationId'
      path: '/case-evaluation/$caseEvaluationId'
      fullPath: '/case-evaluation/$caseEvaluationId'
      preLoaderRoute: typeof BackofficeCaseEvaluationCaseEvaluationIdRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/case-classification_/create': {
      id: '/_backoffice/case-classification_/create'
      path: '/case-classification/create'
      fullPath: '/case-classification/create'
      preLoaderRoute: typeof BackofficeCaseClassificationCreateRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/case-classification_/$caseClassificationId': {
      id: '/_backoffice/case-classification_/$caseClassificationId'
      path: '/case-classification/$caseClassificationId'
      fullPath: '/case-classification/$caseClassificationId'
      preLoaderRoute: typeof BackofficeCaseClassificationCaseClassificationIdRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_dashboard/user_/$userId/edit': {
      id: '/_dashboard/user_/$userId/edit'
      path: '/user/$userId/edit'
      fullPath: '/user/$userId/edit'
      preLoaderRoute: typeof DashboardUserUserIdEditRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings_/form-templates_/create': {
      id: '/_dashboard/settings_/form-templates_/create'
      path: '/settings/form-templates/create'
      fullPath: '/settings/form-templates/create'
      preLoaderRoute: typeof DashboardSettingsFormTemplatesCreateRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_backoffice/raffle_/create_/$caseId': {
      id: '/_backoffice/raffle_/create_/$caseId'
      path: '/raffle/create/$caseId'
      fullPath: '/raffle/create/$caseId'
      preLoaderRoute: typeof BackofficeRaffleCreateCaseIdRouteImport
      parentRoute: typeof BackofficeRoute
    }
  }
}

interface BackofficeRouteChildren {
  BackofficeBranchStatisticsRoute: typeof BackofficeBranchStatisticsRoute
  BackofficeCaseClassificationRoute: typeof BackofficeCaseClassificationRoute
  BackofficeCaseEvaluationRoute: typeof BackofficeCaseEvaluationRoute
  BackofficeNewCasesRoute: typeof BackofficeNewCasesRoute
  BackofficePublicProfileRoute: typeof BackofficePublicProfileRoute
  BackofficeRaffleRoute: typeof BackofficeRaffleRoute
  BackofficeReportStatisticRoute: typeof BackofficeReportStatisticRoute
  BackofficeServingRoute: typeof BackofficeServingRoute
  BackofficeSheriffReportsRoute: typeof BackofficeSheriffReportsRoute
  BackofficeStatisticsRoute: typeof BackofficeStatisticsRoute
  BackofficeStenographicNotesRoute: typeof BackofficeStenographicNotesRoute
  BackofficeCaseClassificationCaseClassificationIdRoute: typeof BackofficeCaseClassificationCaseClassificationIdRoute
  BackofficeCaseClassificationCreateRoute: typeof BackofficeCaseClassificationCreateRoute
  BackofficeCaseEvaluationCaseEvaluationIdRoute: typeof BackofficeCaseEvaluationCaseEvaluationIdRoute
  BackofficeCaseEvaluationCreateRoute: typeof BackofficeCaseEvaluationCreateRoute
  BackofficeCaseFilingsCaseIdRoute: typeof BackofficeCaseFilingsCaseIdRoute
  BackofficeCaseFilingsCreateRoute: typeof BackofficeCaseFilingsCreateRoute
  BackofficeCasePaymentsCaseIdRoute: typeof BackofficeCasePaymentsCaseIdRoute
  BackofficeCaseFilingsIndexRoute: typeof BackofficeCaseFilingsIndexRoute
  BackofficeRaffleCreateCaseIdRoute: typeof BackofficeRaffleCreateCaseIdRoute
}

const BackofficeRouteChildren: BackofficeRouteChildren = {
  BackofficeBranchStatisticsRoute: BackofficeBranchStatisticsRoute,
  BackofficeCaseClassificationRoute: BackofficeCaseClassificationRoute,
  BackofficeCaseEvaluationRoute: BackofficeCaseEvaluationRoute,
  BackofficeNewCasesRoute: BackofficeNewCasesRoute,
  BackofficePublicProfileRoute: BackofficePublicProfileRoute,
  BackofficeRaffleRoute: BackofficeRaffleRoute,
  BackofficeReportStatisticRoute: BackofficeReportStatisticRoute,
  BackofficeServingRoute: BackofficeServingRoute,
  BackofficeSheriffReportsRoute: BackofficeSheriffReportsRoute,
  BackofficeStatisticsRoute: BackofficeStatisticsRoute,
  BackofficeStenographicNotesRoute: BackofficeStenographicNotesRoute,
  BackofficeCaseClassificationCaseClassificationIdRoute:
    BackofficeCaseClassificationCaseClassificationIdRoute,
  BackofficeCaseClassificationCreateRoute:
    BackofficeCaseClassificationCreateRoute,
  BackofficeCaseEvaluationCaseEvaluationIdRoute:
    BackofficeCaseEvaluationCaseEvaluationIdRoute,
  BackofficeCaseEvaluationCreateRoute: BackofficeCaseEvaluationCreateRoute,
  BackofficeCaseFilingsCaseIdRoute: BackofficeCaseFilingsCaseIdRoute,
  BackofficeCaseFilingsCreateRoute: BackofficeCaseFilingsCreateRoute,
  BackofficeCasePaymentsCaseIdRoute: BackofficeCasePaymentsCaseIdRoute,
  BackofficeCaseFilingsIndexRoute: BackofficeCaseFilingsIndexRoute,
  BackofficeRaffleCreateCaseIdRoute: BackofficeRaffleCreateCaseIdRoute,
}

const BackofficeRouteWithChildren = BackofficeRoute._addFileChildren(
  BackofficeRouteChildren,
)

interface DashboardRouteChildren {
  DashboardArticlesRoute: typeof DashboardArticlesRoute
  DashboardBccDashboardRoute: typeof DashboardBccDashboardRoute
  DashboardCalendarRoute: typeof DashboardCalendarRoute
  DashboardCalendarOfEventsRoute: typeof DashboardCalendarOfEventsRoute
  DashboardCaseProcessingRoute: typeof DashboardCaseProcessingRoute
  DashboardCasesRoute: typeof DashboardCasesRoute
  DashboardChangelogsRoute: typeof DashboardChangelogsRoute
  DashboardFormTemplatesRoute: typeof DashboardFormTemplatesRoute
  DashboardHelpRoute: typeof DashboardHelpRoute
  DashboardHelpTopicsRoute: typeof DashboardHelpTopicsRoute
  DashboardJudgeDashboardRoute: typeof DashboardJudgeDashboardRoute
  DashboardNotificationsRoute: typeof DashboardNotificationsRoute
  DashboardOccDashboardRoute: typeof DashboardOccDashboardRoute
  DashboardProfileRoute: typeof DashboardProfileRoute
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardTextEditorRoute: typeof DashboardTextEditorRoute
  DashboardTibolRoute: typeof DashboardTibolRoute
  DashboardUsersRoute: typeof DashboardUsersRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardArticlesArticleIdRoute: typeof DashboardArticlesArticleIdRoute
  DashboardArticlesCreateRoute: typeof DashboardArticlesCreateRoute
  DashboardBranchBranchIdRoute: typeof DashboardBranchBranchIdRoute
  DashboardCalendarSelectedDateRoute: typeof DashboardCalendarSelectedDateRoute
  DashboardCaseProcessingCaseIdRoute: typeof DashboardCaseProcessingCaseIdRoute
  DashboardCasesCaseIdRoute: typeof DashboardCasesCaseIdRoute
  DashboardFormTemplatesFormIdRoute: typeof DashboardFormTemplatesFormIdRoute
  DashboardHelpTopicsTopicIdRoute: typeof DashboardHelpTopicsTopicIdRoute
  DashboardHelpTopicsCreateRoute: typeof DashboardHelpTopicsCreateRoute
  DashboardProfileProfileIdRoute: typeof DashboardProfileProfileIdRoute
  DashboardServingServingIdRoute: typeof DashboardServingServingIdRoute
  DashboardSettingsArticleCategoriesRoute: typeof DashboardSettingsArticleCategoriesRoute
  DashboardSettingsBranchRoute: typeof DashboardSettingsBranchRoute
  DashboardSettingsCaseCategoryRoute: typeof DashboardSettingsCaseCategoryRoute
  DashboardSettingsCaseStagesRoute: typeof DashboardSettingsCaseStagesRoute
  DashboardSettingsCaseTypeRoute: typeof DashboardSettingsCaseTypeRoute
  DashboardSettingsCourtLevelRoute: typeof DashboardSettingsCourtLevelRoute
  DashboardSettingsCourtTypeRoute: typeof DashboardSettingsCourtTypeRoute
  DashboardSettingsCourtTypeStationRoute: typeof DashboardSettingsCourtTypeStationRoute
  DashboardSettingsFormTemplatesRoute: typeof DashboardSettingsFormTemplatesRoute
  DashboardSettingsHelpCategoriesRoute: typeof DashboardSettingsHelpCategoriesRoute
  DashboardSettingsKeywordsRoute: typeof DashboardSettingsKeywordsRoute
  DashboardSettingsProvinceRoute: typeof DashboardSettingsProvinceRoute
  DashboardSettingsRegionRoute: typeof DashboardSettingsRegionRoute
  DashboardSettingsRolesRoute: typeof DashboardSettingsRolesRoute
  DashboardSettingsUserAuditLogsRoute: typeof DashboardSettingsUserAuditLogsRoute
  DashboardUserCreateRoute: typeof DashboardUserCreateRoute
  DashboardUsersUserIdRoute: typeof DashboardUsersUserIdRoute
  DashboardSettingsFormTemplatesCreateRoute: typeof DashboardSettingsFormTemplatesCreateRoute
  DashboardUserUserIdEditRoute: typeof DashboardUserUserIdEditRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardArticlesRoute: DashboardArticlesRoute,
  DashboardBccDashboardRoute: DashboardBccDashboardRoute,
  DashboardCalendarRoute: DashboardCalendarRoute,
  DashboardCalendarOfEventsRoute: DashboardCalendarOfEventsRoute,
  DashboardCaseProcessingRoute: DashboardCaseProcessingRoute,
  DashboardCasesRoute: DashboardCasesRoute,
  DashboardChangelogsRoute: DashboardChangelogsRoute,
  DashboardFormTemplatesRoute: DashboardFormTemplatesRoute,
  DashboardHelpRoute: DashboardHelpRoute,
  DashboardHelpTopicsRoute: DashboardHelpTopicsRoute,
  DashboardJudgeDashboardRoute: DashboardJudgeDashboardRoute,
  DashboardNotificationsRoute: DashboardNotificationsRoute,
  DashboardOccDashboardRoute: DashboardOccDashboardRoute,
  DashboardProfileRoute: DashboardProfileRoute,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardTextEditorRoute: DashboardTextEditorRoute,
  DashboardTibolRoute: DashboardTibolRoute,
  DashboardUsersRoute: DashboardUsersRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardArticlesArticleIdRoute: DashboardArticlesArticleIdRoute,
  DashboardArticlesCreateRoute: DashboardArticlesCreateRoute,
  DashboardBranchBranchIdRoute: DashboardBranchBranchIdRoute,
  DashboardCalendarSelectedDateRoute: DashboardCalendarSelectedDateRoute,
  DashboardCaseProcessingCaseIdRoute: DashboardCaseProcessingCaseIdRoute,
  DashboardCasesCaseIdRoute: DashboardCasesCaseIdRoute,
  DashboardFormTemplatesFormIdRoute: DashboardFormTemplatesFormIdRoute,
  DashboardHelpTopicsTopicIdRoute: DashboardHelpTopicsTopicIdRoute,
  DashboardHelpTopicsCreateRoute: DashboardHelpTopicsCreateRoute,
  DashboardProfileProfileIdRoute: DashboardProfileProfileIdRoute,
  DashboardServingServingIdRoute: DashboardServingServingIdRoute,
  DashboardSettingsArticleCategoriesRoute:
    DashboardSettingsArticleCategoriesRoute,
  DashboardSettingsBranchRoute: DashboardSettingsBranchRoute,
  DashboardSettingsCaseCategoryRoute: DashboardSettingsCaseCategoryRoute,
  DashboardSettingsCaseStagesRoute: DashboardSettingsCaseStagesRoute,
  DashboardSettingsCaseTypeRoute: DashboardSettingsCaseTypeRoute,
  DashboardSettingsCourtLevelRoute: DashboardSettingsCourtLevelRoute,
  DashboardSettingsCourtTypeRoute: DashboardSettingsCourtTypeRoute,
  DashboardSettingsCourtTypeStationRoute:
    DashboardSettingsCourtTypeStationRoute,
  DashboardSettingsFormTemplatesRoute: DashboardSettingsFormTemplatesRoute,
  DashboardSettingsHelpCategoriesRoute: DashboardSettingsHelpCategoriesRoute,
  DashboardSettingsKeywordsRoute: DashboardSettingsKeywordsRoute,
  DashboardSettingsProvinceRoute: DashboardSettingsProvinceRoute,
  DashboardSettingsRegionRoute: DashboardSettingsRegionRoute,
  DashboardSettingsRolesRoute: DashboardSettingsRolesRoute,
  DashboardSettingsUserAuditLogsRoute: DashboardSettingsUserAuditLogsRoute,
  DashboardUserCreateRoute: DashboardUserCreateRoute,
  DashboardUsersUserIdRoute: DashboardUsersUserIdRoute,
  DashboardSettingsFormTemplatesCreateRoute:
    DashboardSettingsFormTemplatesCreateRoute,
  DashboardUserUserIdEditRoute: DashboardUserUserIdEditRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  BackofficeRoute: BackofficeRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
  CaseFilingRoute: CaseFilingRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  HelpCenterRoute: HelpCenterRoute,
  HelpCenter2Route: HelpCenter2Route,
  HelpGuidesRoute: HelpGuidesRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  SentryErrorTestRoute: SentryErrorTestRoute,
  EmailVerifyRoute: EmailVerifyRoute,
  SettingsActiveUserSessionsRoute: SettingsActiveUserSessionsRoute,
  SettingsCaseActivitySettingsRoute: SettingsCaseActivitySettingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
